import { render, staticRenderFns } from "./CCTableAddItems.vue?vue&type=template&id=56242043"
import script from "./CCTableAddItems.vue?vue&type=script&lang=js"
export * from "./CCTableAddItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports